import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { ExportFileFormat, SystemLayout } from '@atmi/core/models';

@Component({
  selector: 'app-export-setting-picker-dialog',
  styleUrls: ['./export-setting-picker-dialog.component.scss'],
  templateUrl: './export-setting-picker-dialog.component.html',
})
export class ExportSettingPickerDialogComponent {

  readonly exportForm = this.formBuilder.group({
    format: [undefined, Validators.required],
    layout: [undefined, Validators.required],
  });

  get layouts() {
    return this.data.layouts.filter((l) => l.fileFormat === this.exportForm.value.format);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: { fileFormats: ExportFileFormat[], layouts: SystemLayout[] },
    private readonly dialogRef: MatDialogRef<ExportSettingPickerDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
  ) {
  }

  closeHandler() {
    this.dialogRef.close();
  }

  exportHandler() {
    if (this.exportForm.invalid) {
      this.exportForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.exportForm.value);
  }

}
